import React, { memo, Fragment } from 'react';
import { createUseStyles, Icon, Text, FilePicker, useTheme } from 'hoi-poi-ui';
import { useWeb5Context } from "../../../../lib/Web5Context";
import StepContent from "../StepContent";
import ExcelIcon from "../../icons/ExcelIcon";
import UploadIcon from "../../icons/UploadIcon";
import { FILE_TYPES } from "../../constants";
import styles from "./styles";
const useStyles = createUseStyles(styles, 'UploadFile');
var _ref2 = /*#__PURE__*/React.createElement(UploadIcon, null);
var _ref3 = /*#__PURE__*/React.createElement(ExcelIcon, null);
const UploadFile = _ref => {
  let {
    entityLabel,
    uploadDescriptionLabel,
    file,
    onRemove,
    onDrop
  } = _ref;
  const classes = useStyles();
  const {
    t
  } = useWeb5Context();
  const theme = useTheme();
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.stepWrapper
  }, /*#__PURE__*/React.createElement(StepContent, null, /*#__PURE__*/React.createElement("div", {
    className: classes.row
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.rowIcon
  }, _ref2), /*#__PURE__*/React.createElement(Text, {
    bold: true
  }, t(uploadDescriptionLabel, [entityLabel]))), file && /*#__PURE__*/React.createElement("div", {
    className: classes.file
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.fileContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.excelIcon
  }, _ref3), /*#__PURE__*/React.createElement(Text, {
    className: classes.fileName,
    type: "badges",
    color: theme.colors.textLight.secondary
  }, file.name), /*#__PURE__*/React.createElement(Icon, {
    size: "small",
    name: "close",
    onClick: onRemove
  }))), !file && /*#__PURE__*/React.createElement(FilePicker, {
    title: t('cfm_label_drag_and_drop_here'),
    buttonLabel: t('cfm_action_select_file'),
    onDrop: onDrop,
    files: file || [],
    accept: FILE_TYPES,
    limit: 1
  }))));
};
process.env.NODE_ENV !== "production" ? UploadFile.propTypes = {} : void 0;
export default /*#__PURE__*/memo(UploadFile);